import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useBefundBogen } from "../../context/BefundbogenContext";
import styles from "./Diagnose.module.css";
import { generateDiagnosePdf } from "../../utils/generateDiagnosePdf";

export default function Diagnose() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { state } = useLocation();
  const { befundData, clearBefundData } = useBefundBogen();

  const result = befundData?.result || state?.result;

  if (!result) {
    return (
      <div className="diagnose-container empty-state">
        <h2>Kein Ergebnis vorhanden</h2>
        <p className="diagnose-text muted">
          Bitte füllen Sie zuerst das Befundformular aus.
        </p>
        <div className="diagnose-actions">
          <button className="new-patient-btn" onClick={() => navigate("/diabetesBefundForm")}>
            Zurück zum Formular
          </button>
        </div>
      </div>
    );
  }

  // Determine which foot caused the highest risk group
  const riskSource =
    result.higher_risk_group_source === "left"
      ? "linken Fußes"
      : result.higher_risk_group_source === "right"
      ? "rechten Fußes"
      : null;

 return (
  <div className={styles["diagnose-container"]}>
    <h1>Bewertung</h1>
    {/* Linker + Rechter Fuß – same row */}
    <div className={styles["diagnose-grid"]}>
      <section className={styles["diagnose-block"]}>
        <h3>Linker Fuß</h3>
        <p className={styles["diagnose-text"]}>
          <strong>Risikogruppe:</strong><br />
          {result.risk_groups_left}
        </p>
        <p className={styles["diagnose-text"]}>
          <strong>Symptome:</strong><br />
          {result.symptoms_left?.length
            ? result.symptoms_left.join(", ")
            : "Keine"}
        </p>
        <p className={styles["diagnose-text"]}>
          <strong>Kriterien:</strong><br />
          {result.criteria_left?.length
            ? result.criteria_left.join(", ")
            : "Keine"}
        </p>
        <p className={styles["diagnose-text"]}>
          <strong>Bewertung:</strong><br />
          {result.left_description}
        </p>
        {/* <p className={styles["recipe-title"]}>Rezeptvorschlag:</p>
        <p className={styles["recipe-text"]}>
          {result.left_recipe_suggestion}
        </p> */}
      </section>
      <section className={styles["diagnose-block"]}>
        <h3>Rechter Fuß</h3>
        <p className={styles["diagnose-text"]}>
          <strong>Risikogruppe:</strong><br />
          {result.risk_groups_right}
        </p>
        <p className={styles["diagnose-text"]}>
          <strong>Symptome:</strong><br />
          {result.symptoms_right?.length
            ? result.symptoms_right.join(", ")
            : "Keine"}
        </p>
        <p className={styles["diagnose-text"]}>
          <strong>Kriterien:</strong><br />
          {result.criteria_right?.length
            ? result.criteria_right.join(", ")
            : "Keine"}
        </p>
        <p className={styles["diagnose-text"]}>
          <strong>Bewertung:</strong><br />
          {result.right_description}
        </p>
        {/* <p className={styles["recipe-title"]}>Rezeptvorschlag:</p>
        <p className={styles["recipe-text"]}>
          {result.right_recipe_suggestion}
        </p> */}
      </section>
    </div>

    {/* Gesamtbewertung */}
    <section className={`${styles["diagnose-block"]} ${styles["full-width"]} ${styles["gesamtbewertung-block"]}`}>
      <h3 className={styles["gesamtbewertung-title"]}>Gesamtbewertung</h3>
      <p className={styles["diagnose-text"]}>
        <strong>Höchste Risikogruppe:</strong><br />
        {result.higher_risk_group}
      </p>
      <p className={styles["diagnose-text"]}>
        {result.higher_risk_recipe_description}
      </p>
      <p className={styles["diagnose-text"]}>
        <strong>Rezeptvorschlag:</strong><br />
        {result.higher_risk_recipe_suggestion}
      </p>
      {riskSource && (
        <p className={`${styles["diagnose-text"]} ${styles["bold-italic"]}`}>
          Hinweis: Diese Gesamtbewertung basiert auf dem Befund des {riskSource}, da dieser Fuß die <strong>höchste Risikogruppe</strong> aufweist.
        </p>
      )}
    </section>

    {/* Hinweis */}
    <section className={`${styles["diagnose-warning"]} ${styles["full-width"]}`}>
      <h4>Bitte beachten Sie</h4>
      <p>
        Das Ergebnis basiert auf den{" "}
        <a
          href="https://ag-fuss-ddg.de/fileadmin/user_upload/Risikogruppeneinteilung_zur_PG31.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          Leitlinien der DDG Arbeitsgemeinschaft Diabetischer Fußleitlinien
        </a>
        , aber es benötigt immer die ärztliche Expertise.
      </p>
      <p>
        Außerdem ist ab Risikogruppe 7 bei einseitig akuter Diagnose immer zu
        prüfen, ob der nicht akut betroffene Fuß bereits adäquat versorgt ist
        oder noch versorgt werden muss.
      </p>
    </section>

    {/* Actions */}
    <div className={styles["diagnose-actions"]}>
      <button className={styles["new-patient-btn"]} onClick={() => navigate("/diabetesBefundForm")}>
        Zurück
      </button>
      <button
        className={styles["new-patient-btn"]}
        onClick={() => {
          clearBefundData();
          navigate("/diabetesBefundForm");
        }}
      >
        Neue Patienten
      </button>
      <button
        className={styles["new-patient-btn"]}
        onClick={() => generateDiagnosePdf(result)}
      >
        Bewertung PDF generieren
      </button>
    </div>
  </div>
);
}
